import MuiChip, { ChipProps } from '@mui/material/Chip';
import ClearRoundedIcon from '@mui/icons-material/ClearRounded';
import makeStyles from '@mui/styles/makeStyles';
import { getDataPropsFromRest } from 'utilities/Utils';
import { StyledEngineProvider } from '@mui/material';

type ChipPropsType = {
  label: React.ReactNode;
  disabled?: boolean;
  className?: string;
  deleteIcon?: React.ReactElement;
  onDelete?: () => void;
  size?: 'small' | 'medium';
  color?: 'default' | 'success';
  onClick?: () => void;
};

const useStyles = makeStyles(theme => ({
  deletableCls: {
    border: `1.5px solid ${theme.palette.primary.main} !important`,
  },
  root: {
    borderRadius: '16px',
    height: '32px',
    fontSize: '14px',
    color: '#404040',
    fontWeight: 400,
    lineHeight: '16px',
    background: theme.palette.backgrounds.white,
    border: `1px solid ${theme.palette.backgrounds.divider}`,
    '& [class*="MuiChip-deleteIcon"]': {
      color: 'inherit',
      width: '18px',
      cursor: 'pointer',
    },
  },
  success: {
    border: `1px solid ${theme.palette.primary.main}`,
    background: theme.palette.backgrounds.primary,
    '& [class*="MuiChip-deleteIcon"]': {
      color: theme.palette.primary.main,
      width: '18px',
      cursor: 'pointer',
    },
  },
  sizeSmall: {
    height: '20px',
    fontSize: '10px',
    textTransform: 'uppercase',
    letterSpacing: '0.02em',
  },
  labelSmall: {
    padding: '0 6px',
  },
}));

function Chip(props: Partial<ChipPropsType>) {
  const {
    label,
    className = '',
    onDelete = null,
    size = 'medium',
    color = 'default',
    disabled = false,
    onClick = null,
    ...rest
  } = props;

  const classes = useStyles();
  const _color: ChipProps['color'] = 'default';
  const rootCls = `${className} ${classes[color]} ${classes.root}`;
  const dataTestIdProps = getDataPropsFromRest(rest);

  return (
    <StyledEngineProvider injectFirst>
      <MuiChip
        classes={{
          root: rootCls,
          sizeSmall: classes.sizeSmall,
          labelSmall: classes.labelSmall,
        }}
        label={label}
        deleteIcon={<ClearRoundedIcon fontSize="inherit" />}
        onDelete={onDelete}
        size={size}
        color={_color}
        variant="outlined"
        onClick={onClick}
        disabled={disabled}
        {...dataTestIdProps}
      />
    </StyledEngineProvider>
  );
}
export { Chip };
